export const getRoleDisplayName = (role) => {
  switch (role) {
    case 'admin':
      return 'Super Admin';
    case 'manager':
      return 'Admin';
    case 'user':
      return 'User';
    default:
      return '';
  }
};